import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from 'react';

interface CompanyContextType {
  companyId: number | null;
  setCompanyId: (companyId: number | null) => void;
}

const CompanyContext = createContext<CompanyContextType | undefined>(undefined);

export const useCompany = (): CompanyContextType => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
};

interface CompanyProviderProps {
  children: ReactNode;
}

export const CompanyProvider = ({ children }: CompanyProviderProps) => {
  const storedCompanyId = localStorage.getItem('companyId');
  const initialCompanyId = storedCompanyId ? parseInt(storedCompanyId) : null;

  const [companyId, setCompanyId] = useState<number | null>(initialCompanyId);

  useEffect(() => {
    if (companyId !== null) {
      localStorage.setItem('companyId', companyId.toString());
    } else {
      localStorage.removeItem('companyId');
    }
  }, [companyId]);

  return (
    <CompanyContext.Provider value={{ companyId, setCompanyId }}>
      {children}
    </CompanyContext.Provider>
  );
};
